import React, { Fragment } from 'react';

export default function Variant(props) {
  if (React.isValidElement(props.children)) {
    return props.children;
  } else {
    return <Fragment>{props.children}</Fragment>;
  }
}
